import Vue from 'vue'
import Router from 'vue-router'
import PageHome from '@/views/PageHome.vue'
import PageLogin from '@/views/PageLogin.vue'
import PageHistory from '@/views/PageHistory.vue'
import PageEfriends from '@/views/PageEfriends.vue'
import PageEfriendsMap from '@/views/PageEfriendsMap.vue'
import PageSettings from '@/views/PageSettings.vue'
import PagePasswordReset from '@/views/PagePasswordReset.vue'
import PageSelectCube from '@/views/PageSelectCube'
import PageSetNewPassword from '@/views/PageSetNewPassword'
import PageMyData from '@/views/PageMyData'
import PageInvoices from '@/views/PageInvoices'
import PageDownloads from '@/views/PageDownloads'
import PageExperts from '@/views/PageExperts'
import PageAboutApp from '@/views/PageAboutApp'
import PageDevices from '@/views/PageDevices'
import PageDeviceDetail from '@/views/PageDeviceDetail'
import PageNotifications from '@/views/PageNotifications'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'nav__link--active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: PageHome,
    },
    {
      path: '/login',
      name: 'login',
      component: PageLogin,
    },
    {
      path: '/passwort-zuruecksetzen',
      name: 'password-reset',
      component: PagePasswordReset,
    },
    {
      path: '/passwort/:token',
      name: 'new-password',
      component: PageSetNewPassword,
    },
    {
      path: '/select-cube',
      name: 'select-cube',
      component: PageSelectCube,
    },
    {
      path: '/history',
      name: 'history',
      component: PageHistory,
    },
    {
      path: '/efriends',
      name: 'efriends',
      component: PageEfriends,
    },
    {
      path: '/efriends/map/:selected?',
      name: 'map',
      component: PageEfriendsMap,
    },
    {
      path: '/settings',
      name: 'settings',
      component: PageSettings,
    },
    {
      path: '/my-data',
      name: 'my-data',
      component: PageMyData,
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: PageInvoices,
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: PageDownloads,
    },
    {
      path: '/experts',
      name: 'experts',
      component: PageExperts,
    },
    {
      path: '/about-app',
      name: 'about-app',
      component: PageAboutApp,
    },
    {
      path: '/devices',
      name: 'devices',
      component: PageDevices,
    },
    {
      path: '/devices/:deviceid/:tab?',
      name: 'device-detail',
      component: PageDeviceDetail,
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: PageNotifications,
    },
  ],
})
